const CardContainer = ({ title, required, children, icon, className }) => {
  return (
    <div className="bg-neutral overflow-hidden dark:bg-neutral-800 rounded shadow">
      {title && (
        <div
          className={`${className} h-fit w-full flex items-center py-2 px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600`}
        >
          {icon} {title}
          {required ? <span className="text-red-500">*</span> : ""}
        </div>
      )}

      {children}
    </div>
  );
};

export default CardContainer;
